import { createApp } from 'vue'
import FormStepSubmitting from './FormStepSubmitting'

const el = '.kb-component--form-step-submitting'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FormStepSubmittingDOM) => {
            const component = createApp(FormStepSubmitting).use(Store)
            component.mount(FormStepSubmittingDOM)
        })
    }
}
